import { Component } from '@angular/core';

@Component({
  selector: 'stars-guide-elements',
  templateUrl: './guide-elements.component.html',
  styleUrls: ['../../pages/guide.scss']
})
export class GuideElementsComponent {
  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    const sectionPosition = section.offsetTop;
    const offsetPosition = sectionPosition - 150;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}
